module.exports = __webpack_public_path__ + "img/contact_wx.1acc8ded.png";